// extracted by mini-css-extract-plugin
export default {"root":"IconBook_root__796qx"};